<template>
	<div class="box">
		<div class="bg detail-table">
			<div class="title">
				<span class="name">{{$t('workList.draft1')}}</span>
				<div class="search">
					<el-input v-model="search.name" size="small" style="max-width: 180px;"
						:placeholder="$t('articleUnlock.keys')">
					</el-input>
					<el-button style="margin-left: 5px;margin-right: 5px;" class="search-btn" size="small"
						@click="handleClick">{{$t('articleUnlock.inquire')}}
					</el-button>
				</div>
			</div>
			<div style="margin-bottom: 10px;min-height: 350px;" v-if="tableData.length > 0">
				<el-table header-row-class-name="detail-header" ref="multipleTable" :data="tableData" border
					tooltip-effect="dark" style="width: 100%;" @selection-change="handleSelectionChange"
					v-loading="loading">
					<el-table-column type="selection" width="55">
					</el-table-column>
					<el-table-column prop="bookName" :label="$t('workList.Story_title')" width="120" align="center" />
					<el-table-column prop="chapterId" :label="$t('workList.Chapter_ID')" width="80" align="center" />
					<el-table-column prop="name" :label="$t('workList.title')" width="180" show-overflow-tooltip
						align="center" />
					<!-- <el-table-column prop="summary" :label="$t('workList.synopsis')" align="center" /> -->
					<!-- <el-table-column prop="info" :label="$t('workList.classification')" align="center" /> -->
					<el-table-column prop="words" :label="$t('workList.Word_Count')" align="center" />
					<el-table-column prop="isScheduled" :label="$t('workList.time1')" align="center">
						<template slot-scope="scope">
							<a v-if="scope.row.isScheduled == 1">{{$t('workList.yes')}}</a>
							<a v-else>{{$t('workList.no')}}</a>
						</template>
					</el-table-column>
					<el-table-column prop="scheduledTime" :label="$t('workList.time2')" width="160" align="center">
						<template slot-scope="scope">
							<div style="height: 20px; text-overflow:ellipsis; overflow:hidden;">
								<span>{{formatDate(scope.row.scheduledTime)}}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="scheduledTime" :label="$t('workList.publishTime')" width="180"
						align="center">
						<template slot-scope="scope">
							<div style="height: 20px; text-overflow:ellipsis; overflow:hidden;">
								<span>{{formatlocalDate(scope.row.scheduledTime)}}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column :label="$t('workList.operate')" align="center">
						<template slot-scope="scope">
							<template v-if="title == '草稿箱'">
								<div class="work_operate">
									<el-link :underline="false"
										@click="rowClick(scope.row,1)">{{$t('workList.published')}}</el-link>
									<!-- <a @click="rowClick(scope.row,0)">{{$t('workList.time1')}}</a> -->
									<el-link :underline="false"
										@click="rowClick(scope.row,2)">{{$t('workList.Edit')}}</el-link>
									<el-link :underline="false"
										@click="rowClick(scope.row,3)">{{$t('workList.Delete')}}</el-link>
								</div>

							</template>
							<template v-else-if="title == '已发布'">
								<a @click="rowClick(scope.row,4)">{{$t('workList.preview')}}</a>
								<!-- 已发布的不给删除，需联系编辑删除 -->
								<!-- <a @click="rowClick(scope.row,5)">{{$t('workList.Delete')}}</a> -->
							</template>
							<template v-else="title == '回收站'">
								<el-link :underline="false"
									@click="rowClick(scope.row,6)">{{$t('workList.restore')}}</el-link>|
								<el-link :underline="false"
									@click="rowClick(scope.row,7)">{{$t('workList.cancel')}}</el-link>
							</template>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<table-null v-else></table-null>
			<div style="text-align: right;margin-top: 10px;">
				<el-pagination background :hide-on-single-page="true" :page-size="pageSize" :current-page="pageNum"
					layout="prev, pager, next" :total="total" @current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</div>
		<div class="them-btn" style="margin-top: 20px;">
			<template v-if="title == '草稿箱'">
				<el-tooltip class="item" effect="light" :disabled="!handleGuess()"
					content="You need to complete the contract before publishing the chapter." placement="top-start">
					<el-button class="info-updata-btn" size="small" :disabled="handleGuess()"
						@click="publishClick(1)">{{$t('workList.Publish1')}}</el-button>
				</el-tooltip>
				<el-tooltip class="item" effect="light" :disabled="!handleGuess()"
					content="You need to complete the contract before publishing the chapter." placement="top-start">
					<el-button class="info-updata-btn" size="small" :disabled="handleGuess()"
						@click="publishClick(2)">{{$t('workList.Publish2')}}</el-button>
				</el-tooltip>
				<el-button class="info-updata-btn" size="medium"
					@click="publishClick(3)">{{$t('workList.Publish3')}}</el-button>
				<el-button class="info-updata-btn" size="medium" @click="publishClick(6)"
					type="primary">{{$t('workList.Publish4')}}</el-button>
			</template>
			<template v-else-if="title == '已发布'">
				<!-- 已发布的不给删除，需联系编辑删除 -->
				<!-- <el-button class="info-updata-btn" size="small" @click="publishClick(3)">{{$t('workList.Publish3')}} -->
				</el-button>
			</template>
			<template v-else="title == '回收站'">
				<el-button class="info-updata-btn" size="small"
					@click="publishClick(4)">{{$t('workList.Publish4')}}</el-button>
				<el-button class="info-updata-btn" size="small"
					@click="publishClick(5)">{{$t('workList.Publish5')}}</el-button>
			</template>
		</div>
	</div>
</template>

<script>
export default {
  props: {
    hasPublished: {
      type: Boolean,
      default: false
    },
    bookInfo: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    tableData: {
      type: Array,
      default: () => []
    },
    refreshList: {
      type: Function,
      default: null
    },
    total: {
      type: Number,
      default: 0
    },
    pageNum: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      search: {

      },
      multipleSelection: [] // 勾选的数据数组
    }
  },
  methods: {
    handleGuess () {
      if (this.hasPublished === 'true') {
        return false
      } else {
        if (this.bookInfo.signStatus === 1) {
          return false
        }
      }
      return true
    },
    handleClick () {
      // 操作后重新获取数据
      this.$emit('searchChapter', this.search)
    },
    formatDate (Time) { // 获得UTC的时间
      const moment = require('moment-timezone')

      // console.log(" moment.tz.names()", moment.tz.names());

      if (Time == null) {
        return null
      }
      var timezone = 'Asia/Shanghai'
      const clean = moment(Time).format('YYYY-MM-DD HH:mm:ss') // 清除 timezone 信息
      const Shanghailocal = moment.tz(clean, timezone)
      return Shanghailocal.tz('UTC').format('YYYY-MM-DD HH:mm:ss')
    },
    formatlocalDate (Time) { // 获得当地的时间
      const moment = require('moment-timezone')
      if (Time == null) {
        return null
      }
      // console.log("localTimezone",moment.tz.guess());

      var timezone = 'Asia/Shanghai'
      const clean = moment(Time).format('YYYY-MM-DD HH:mm:ss') // 清除 timezone 信息
      // console.log("clearTimezone",moment.tz.guess());
      const Shanghailocal = moment.tz(clean, timezone)

      var localTimeZone = moment.tz.guess()

      return Shanghailocal.tz(localTimeZone).format('YYYY-MM-DD HH:mm:ss')
    },
    handleSelectionChange (val) {
      this.$emit('handleSelectionChange', val)
    },
    fabu (item) {
      // 操作后重新获取数据
      this.$emit('refreshList')
    },
    publishClick (type) {
      this.$emit('publishClick', type)
    },
    rowClick (row, type) {
      this.$emit('rowClick', row, type)
    },
    handleCurrentChange (val) {
      this.$emit('handleCurrentChange', val)
    },
    fromParent (type) {
      console.log('fromParent', type)
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
	.work_operate {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.box {
		.bg {
			background-color: #FFFFFF;
			height: 80%;
			padding: 10px 20px;
			border-radius: 6px;

			.title {
				height: 56px;
				background-color: #FFFFFF;
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;

				.name {
					font-size: 18px;
					font-weight: bold;
					line-height: 50px;
				}
			}

			a {
				cursor: pointer;
			}
		}
	}
</style>
